import type { InventoryListParams } from '@/types';

export const inventoryKeys = {
  all: ['inventory'] as const,
  list: (params?: InventoryListParams) => [...inventoryKeys.all, 'list', params] as const,
  // LR-546: windowed inventory list (matches use-inventory-infinite's inline key).
  infinite: (params?: Omit<InventoryListParams, 'limit' | 'offset'>) => [...inventoryKeys.all, 'infinite', params] as const,
  states: () => [...inventoryKeys.all, 'states'] as const,
  positions: () => [...inventoryKeys.all, 'positions'] as const,
  filters: () => [...inventoryKeys.all, 'filters'] as const,
} as const;
